<template>
    <div>
        <sav-template
        :title="$t('accueil.title')"
        :back-button="false"
        >   
            <continue-card v-if="formWaiting"></continue-card>

            <div v-if="!formWaiting" id="new-form-container" class="p-6 my-2 text-center shadow my-rounded" style="background: #dfe5f0; color: #5c5f66">
                <h3 class="mb-1 text-xl font-bold">
                    <i class="mr-2 fas fa-plus-circle"></i>{{ $t('accueil.demande_de_sav') }}
                </h3>
                <p class="mb-2">
                    <small>{{ $t('accueil.un_souci_avec_un_produit_il_vous_suffit_de_commencer_une_nouvelle_demande_de_sav') }}</small>
                </p>
                <router-link :to="{ name: 'form.home'}" class="text-white text-decoration-none">
                    <button class="inline-block px-3 py-1 font-normal leading-normal text-center text-white no-underline whitespace-no-wrap align-middle border rounded select-none" style="background: #5c5f66;">
                        {{ $t('accueil.commencer') }}
                    </button>
                </router-link>
            </div>
        </sav-template>
    </div>
</template>

<script>
import ContinueCard from '@/processes/cards/other/ContinueCard.vue'

export default {
    components: { ContinueCard },

    computed: {
        formWaiting() {
            return localStorage.getItem('form-data') ? true : false
        }
    },
    methods: {
        removeWaitingForm() {
            localStorage.removeItem('form-data')
            this.$router.go()
        },

        continueForm() {
            this.$router.push({name: 'form.home'})
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/marketmaker/views/Home.vue